var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconDefault({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499.19 280.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.37,280.75c-11.24,0-23.43-4.83-33.95-16.88C-.96,248.57-.73,233.15.61,225.33c3.98-23.3,20.92-42.54,37.3-61.15.52-.59,1.07-1.21,1.63-1.86,11.93-13.58,11.65-34.04-.69-47.25-.06-.07-.13-.13-.19-.2C22,97.04,4.75,78.6.65,55.44v-.02c-1.4-7.93-1.71-23.53,11.98-38.92C30.67-3.67,53.33-3.13,67.81,6.3c29.61,19.31,84.97,81.51,85.24,131.56.26,48.83-50.21,113.41-85.08,136.42-6.1,4.03-13.61,6.47-21.61,6.47Z",
    fill: "#fab92b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.44,280.75c-11.24,0-23.43-4.83-33.95-16.88-13.38-15.3-13.14-30.72-11.81-38.54,3.98-23.3,20.92-42.54,37.3-61.15.52-.59,1.07-1.21,1.63-1.86,11.93-13.58,11.65-34.04-.69-47.25-.06-.07-.13-.13-.19-.2-16.67-17.84-33.91-36.28-38.02-59.44v-.02c-1.4-7.93-1.71-23.53,11.98-38.92,18.04-20.17,40.7-19.63,55.18-10.19,29.61,19.31,84.97,81.51,85.24,131.56.26,48.83-50.21,113.41-85.08,136.42-6.1,4.03-13.61,6.47-21.61,6.47Z",
    fill: "#fab92b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.5,280.75c-11.24,0-23.43-4.83-33.95-16.88-13.38-15.3-13.14-30.72-11.81-38.54,3.98-23.3,20.92-42.54,37.3-61.15.52-.59,1.07-1.21,1.63-1.86,11.93-13.58,11.65-34.04-.69-47.25-.06-.07-.13-.13-.19-.2-16.67-17.84-33.91-36.28-38.02-59.44v-.02c-1.4-7.93-1.71-23.53,11.98-38.92,18.04-20.17,40.7-19.63,55.18-10.19,29.61,19.31,84.97,81.51,85.24,131.56.26,48.83-50.21,113.41-85.08,136.42-6.1,4.03-13.61,6.47-21.61,6.47Z",
    fill: "#fab92b",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconDefault);
export default __webpack_public_path__ + "static/media/logo_icon_default.7ef5b6e725185689523e4004b2182d80.svg";
export { ForwardRef as ReactComponent };